import { requestApi } from '@app/api';
import { withDocument } from '@app/api/paths';

export function postDocumentsForwardingEmail({
  documentId,
  recipientEmail,
  senderName,
  workspaceId,
}: {
  documentId: string;
  recipientEmail: string;
  senderName: string;
  workspaceId: string;
}) {
  return requestApi({
    url: withDocument(`/workspaces/${workspaceId}/documents/${documentId}/forwarding/email`),
    method: 'POST',
    data: {
      senderName,
      recipientEmail,
    },
    credentials: true,
  });
}
